import audioLight from '@rbx/foundation-images/pictograms/audio_light.svg';
import audioDark from '@rbx/foundation-images/pictograms/audio_dark.svg';
import experiencesLight from '@rbx/foundation-images/pictograms/video_game_light.svg';
import experiencesDark from '@rbx/foundation-images/pictograms/video_game_dark.svg';
import eventsAndUpdatesLight from '@rbx/foundation-images/pictograms/event_calendar_light.svg';
import eventsAndUpdatesDark from '@rbx/foundation-images/pictograms/event_calendar_dark.svg';
import shareLinksLight from '@rbx/foundation-images/pictograms/shareLinks_light.svg';
import shareLinksDark from '@rbx/foundation-images/pictograms/shareLinks_dark.svg';
import signinLight from '@rbx/foundation-images/pictograms/signin_light.svg';
import signinDark from '@rbx/foundation-images/pictograms/signin_dark.svg';
import avatarItemLight from '@rbx/foundation-images/pictograms/avatar_setup_light.svg';
import avatarItemDark from '@rbx/foundation-images/pictograms/avatar_setup_dark.svg';
import modelsLight from '@rbx/foundation-images/pictograms/models_light.svg';
import modelsDark from '@rbx/foundation-images/pictograms/models_dark.svg';
import pluginsLight from '@rbx/foundation-images/pictograms/models_plugins_parts_light.svg';
import pluginsDark from '@rbx/foundation-images/pictograms/models_plugins_parts_dark.svg';
import imagesLight from '@rbx/foundation-images/pictograms/image_light.svg';
import imagesDark from '@rbx/foundation-images/pictograms/image_dark.svg';
import videosLight from '@rbx/foundation-images/pictograms/video_light.svg';
import videosDark from '@rbx/foundation-images/pictograms/video_dark.svg';
import animationsLight from '@rbx/foundation-images/pictograms/run_light.svg';
import animationsDark from '@rbx/foundation-images/pictograms/run_dark.svg';
import collaboratorsLight from '@rbx/foundation-images/pictograms/collaborators_light.svg';
import collaboratorsDark from '@rbx/foundation-images/pictograms/collaborators_dark.svg';
import localizationLight from '@rbx/foundation-images/pictograms/localization_light.svg';
import localizationDark from '@rbx/foundation-images/pictograms/localization_dark.svg';
import rightsManagerLight from '@rbx/foundation-images/pictograms/rights_manager_light.svg';
import rightsManagerDark from '@rbx/foundation-images/pictograms/rights_manager_dark.svg';
import tokensLight from '@rbx/foundation-images/pictograms/token_light.svg';
import tokensDark from '@rbx/foundation-images/pictograms/token_dark.svg';
import lockLight from '@rbx/foundation-images/pictograms/lockSecrets_light.svg';
import lockDark from '@rbx/foundation-images/pictograms/lockSecrets_dark.svg';
import notificationsLight from '@rbx/foundation-images/pictograms/notifications_light.svg';
import notificationsDark from '@rbx/foundation-images/pictograms/notifications_dark.svg';
import chartLight from '@rbx/foundation-images/pictograms/line_chart_light.svg';
import chartDark from '@rbx/foundation-images/pictograms/line_chart_dark.svg';
import badgeLight from '@rbx/foundation-images/pictograms/badge_light.svg';
import badgeDark from '@rbx/foundation-images/pictograms/badge_dark.svg';
import decalsLight from '@rbx/foundation-images/pictograms/decals_light.svg';
import decalsDark from '@rbx/foundation-images/pictograms/decals_dark.svg';
import meshesLight from '@rbx/foundation-images/pictograms/meshes_light.svg';
import meshesDark from '@rbx/foundation-images/pictograms/meshes_dark.svg';
import apiKeysLight from '@rbx/foundation-images/pictograms/api_key_light.svg';
import apiKeysDark from '@rbx/foundation-images/pictograms/api_key_dark.svg';
import oAuthAppsLight from '@rbx/foundation-images/pictograms/oauth_light.svg';
import oAuthAppsDark from '@rbx/foundation-images/pictograms/oauth_dark.svg';
import makeupLooksLight from '@rbx/foundation-images/pictograms/makeup_look_light.svg';
import makeupLooksDark from '@rbx/foundation-images/pictograms/makeup_look_dark.svg';
import barGraphLight from '@rbx/foundation-images/pictograms/bar_graph_light.svg';
import barGraphDark from '@rbx/foundation-images/pictograms/bar_graph_dark.svg';
import findPeopleLight from '@rbx/foundation-images/pictograms/find_people_light.svg';
import findPeopleDark from '@rbx/foundation-images/pictograms/find_people_dark.svg';
import managedPricingLight from '@rbx/foundation-images/pictograms/managed_pricing_light.svg';
import managedPricingDark from '@rbx/foundation-images/pictograms/managed_pricing_dark.svg';

const emptyStateIllustrations = {
  secrets: {
    light: lockLight,
    dark: lockDark,
  },
  noPermissions: {
    light: lockLight,
    dark: lockDark,
  },
  notifications: {
    light: notificationsLight,
    dark: notificationsDark,
  },
  experiences: {
    light: experiencesLight,
    dark: experiencesDark,
  },
  shareLinks: {
    light: shareLinksLight,
    dark: shareLinksDark,
  },
  eventsAndUpdates: {
    light: eventsAndUpdatesLight,
    dark: eventsAndUpdatesDark,
  },
  avatarItem: {
    light: avatarItemLight,
    dark: avatarItemDark,
  },
  models: {
    light: modelsLight,
    dark: modelsDark,
  },
  plugins: {
    light: pluginsLight,
    dark: pluginsDark,
  },
  audio: {
    light: audioLight,
    dark: audioDark,
  },
  decals: {
    light: decalsLight,
    dark: decalsDark,
  },
  images: {
    light: imagesLight,
    dark: imagesDark,
  },
  videos: {
    light: videosLight,
    dark: videosDark,
  },
  meshes: {
    light: meshesLight,
    dark: meshesDark,
  },
  animations: {
    light: animationsLight,
    dark: animationsDark,
  },
  noUsers: {
    light: collaboratorsLight,
    dark: collaboratorsDark,
  },
  localization: {
    light: localizationLight,
    dark: localizationDark,
  },
  rightsManager: {
    light: rightsManagerLight,
    dark: rightsManagerDark,
  },
  tokens: {
    light: tokensLight,
    dark: tokensDark,
  },
  chart: {
    light: chartLight,
    dark: chartDark,
  },
  badge: {
    light: badgeLight,
    dark: badgeDark,
  },
  apiKeys: {
    light: apiKeysLight,
    dark: apiKeysDark,
  },
  signin: {
    light: signinLight,
    dark: signinDark,
  },
  oAuthApps: {
    light: oAuthAppsLight,
    dark: oAuthAppsDark,
  },
  makeupLooks: {
    light: makeupLooksLight,
    dark: makeupLooksDark,
  },
  barGraph: {
    light: barGraphLight,
    dark: barGraphDark,
  },
  findPeople: {
    light: findPeopleLight,
    dark: findPeopleDark,
  },
  managedPricing: {
    light: managedPricingLight,
    dark: managedPricingDark,
  },
};

export default emptyStateIllustrations;
